import { useState, useEffect } from "react";
import { useConnectedUser } from "../stores/useConnectedUser";
import { useGetProfile } from "../generated/hook";

export const useTokenVerification = () => {
  const { setFirstName, setLastName, clear } = useConnectedUser();
  const [isInitialized, setIsInitialized] = useState(false);

  const { data, error } = useGetProfile({
    query: {
      retry: (failureCount, error: any) => {
        // Stop retrying if we get a 401 error
        if (error?.response?.status === 401 || error?.data?.status === 401)
          return false;
        // Retry up to 3 times with exponential backoff
        return failureCount < 3;
      },
      refetchInterval: 120000, // 2 minutes in milliseconds
      refetchIntervalInBackground: false, // Don't refetch when window is not focused
      refetchOnWindowFocus: false, // Don't refetch when window regains focus
    },
  });

  useEffect(() => {
    // Initialize verification when component mounts
    if (!isInitialized) {
      // The useVerify hook will automatically trigger verification
      setIsInitialized(true);
    }
  }, [isInitialized]);

  useEffect(() => {
    if (error) {
      // Cookies.remove('token');
      clear();
    } else if (data) {
      setFirstName(data.displayName || null);
      setLastName(data.displayName || null);
    }
  }, [data, error, clear, setFirstName, setLastName]);

  return { isInitialized };
};
